import { nebulaClient2 } from "../../lib/nebulaClient";
import { UserManagementService } from "./nebula.service";
import { User, SiteUser, assignGroupsToUserType } from "./types";

export const userManagementService: UserManagementService = {
    getUsers: async () => {
        const response = await nebulaClient2.get<{ usersFromSites: SiteUser[]; usersFromTrials: User[] }>("/users");
        return response;
    },

    getRoles: async () => {
        const response = await nebulaClient2.get<string[]>("/user/roles");
        return response;
    },

    checkUserExists: async (email: string) => {
        const response = await nebulaClient2.get<{ exists: boolean }>(`/user/email-exists/${email}`);
        return response;
    },

    getSites: async (trialId: string) => {
        const response = await nebulaClient2.get<{ name: string; uuid: string }[]>(`/trial/${trialId}/sites`);
        return response;
    },

    getTrialsUserManagement: async () => {
        const response = await nebulaClient2.get<{ name: string; uuid: string }[]>("/user/trials");
        return response;
    },

    createUser: async (user) => {
        const response = await nebulaClient2.post<User | SiteUser>("/user", user);
        return response;
    },

    updateUser: async (userId, user) => {
        const parsedUser = {
            firstName: user.firstName,
            lastName: user.lastName,
            accessExpires: new Date(user.accessExpires!).toISOString(),
            activated: user.activated,
            certificationRequired: user.certificationRequired,
        };
        const response = await nebulaClient2.put<User>(`/user/${userId}`, parsedUser);
        return response;
    },

    assignGroupsToUser: async (userId, affiliationType, assignTo) => {
        const response = await nebulaClient2.put<assignGroupsToUserType[]>(`/user/${userId}/assign`, {
            affiliationType,
            assignTo,
        });
        return response;
    },

    editUserRoles: async (userId, roles) => {
        const response = await nebulaClient2.put<{ userId: string; roles: string[] }>(`/user/${userId}/update-roles`, {
            roles,
        });
        return response;
    },
    createSite: async (site) => {
        const response = await nebulaClient2.post<{ name: string; uuid: string }>(`/trial/${site.trialId}/site`, {
            name: site.name,
            countryCode: site.countryCode,
        });
        return response;
    },
};
